import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import FeaturedSlider from "../components/FeaturedSlider";
import ArticleCard from "../components/ArticleCard";
import Sidebar from "../components/Sidebar";
import LatestArticlesSidebar from "../components/LatestArticlesSidebar";
import SEO from "../seo";
import API from "../api/api";

export default function HomePage() {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        API
            .get("/articles/articlelist")
            .then((res) => setArticles(res.data))
            .catch((err) => console.log("Error fetching articles:", err));
    }, []);

    // ---- GROUP ARTICLES BY CATEGORY ----
    const grouped = {};

    articles.forEach((a) => {
        if (!grouped[a.category]) grouped[a.category] = [];
        grouped[a.category].push(a);
    });

    const categories = Object.keys(grouped);

    return (
        <>{/* ✅ Homepage SEO */}
            <SEO
                title="TechArticleHub | Tech News, Programming & AI Tutorials"
                description="Tech Article Hub offers latest tech news, programming, coding, and software tips. Learn Python, JavaScript, AI, and more."
                canonical="https://techarticlehub.com/"
                image="https://techarticlehub.com/logo.png"
            />

            <div className="max-w-7xl mx-auto px-6 pt-6 pb-4">
                {/* ✅ SEO H1 (hidden visually, safe for Google) */}
                <h1 className="sr-only">
                    Latest Tech News, Programming Tutorials & Coding Guides
                </h1>

                {/* ✅ Visible UI text (clean & minimal) */}
                <p className="sr-only">
                    Learn programming, explore AI, DevOps, cybersecurity, and stay updated
                    with the latest technology trends.
                </p>

            </div>
            <div className="w-full">
                <FeaturedSlider />

                {/* MAIN CONTENT */}
                <div className="px-6 mt-10 grid grid-cols-1 lg:grid-cols-4 gap-10">

                    {/* LEFT SIDE — ARTICLES */}
                    <div className="lg:col-span-3">

                        {categories.map((cat) => (
                            <div key={cat} className="mb-12">

                                {/* CATEGORY TITLE */}
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-2xl font-bold border-l-4 border-blue-600 pl-3">
                                        {cat}
                                    </h2>

                                    {grouped[cat].length > 6 && (
                                        <Link
                                            to={`/category/${cat}`}
                                            className="text-blue-600 text-sm font-semibold hover:underline"
                                        >
                                            View All →
                                        </Link>
                                    )}
                                </div>

                                {/* ARTICLE GRID */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                                    {grouped[cat]
                                        .slice(0, 6)
                                        .map((article) => (
                                            <ArticleCard
                                                key={article.id}
                                                slug={article.slug}
                                                img={article.images}
                                                title={article.title}
                                                category={article.category}
                                            />
                                        ))}
                                </div>

                                {grouped[cat].length === 0 && (
                                    <p className="text-gray-500 text-sm">
                                        No articles available.
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* RIGHT SIDEBAR (SINGLE COLUMN) */}
                    <div className="lg:col-span-1 space-y-8">
                        <Sidebar />
                        <LatestArticlesSidebar />
                    </div>
                </div>
            </div>
        </>
    );
}


